<script>
// import macarons from "@/common/theme.json";
// import cloneDeep from "lodash/cloneDeep";
// import sortBy from "lodash/sortBy";
// import moment from "moment";
const mapWorth4 = {
  "2": {result: "右眼抑制", msg: "双眼视觉信息无法同时使用，建议脱抑制训练+同时视训练"},
  "3": {result: "左眼抑制", msg: "双眼视觉信息无法同时使用，建议脱抑制训练+同时视训练"},
  "4": {result: "正常", msg: "具备正常的同时视功能"},
  "5": {result: "复视", msg: "具备同时视，但融合功能不足，建议融合训练"},
  "2.5": {result: "交替抑制", msg:"双眼视觉信息无法同时使用，建议脱抑制训练+同时视训练"}
};
export default {
  props: {
    testResult: Object,
    testUser: Object
  },
  data() {
    let picInfo = "";
    if (this.testResult && this.testResult.picInfo) {
      picInfo = this.testResult.picInfo;
    }
    let user = {
      name: undefined,
      gender: undefined,
      date: undefined
    };
    if (this.testUser) {
      user = this.testUser;
    }
    return {
      user: {
        name: "--",
        gender: "--",
        date: "--"
      },
      picInfo: picInfo,
      checkResult: {
        versionOd: '',
        versionOs: '',
        worth4Number: '',
        worth4Text: '',
        positionSuanshuShuiping: '',
        positionSuanshuChuizhi: '',
        positionPingjunShuiping: '',
        positionPingjunChuizhi: '',
        xiantiaorongheFenkai: '',
        xiantiaorongheFucou: '',
        // dafanweilitishiDongtai: '',
        dafanweilitishijingtai: '',
        xiantiaolitishi: '',
        ruoshiyizhipinghengdian: '',
        xieshiyizhipinghengdian: '',
        zhijueyanweiEvaluateShuiping: '',
        zhijueyanweiEvaluateShuipingSug: '',
        zhijueyanweiEvaluateChuizhi: '',
        zhijueyanweiEvaluateChuizhiSug: '',
        xiantiaorongheEvaluateFenkai: '',
        xiantiaorongheEvaluateFenkaiSug: '',
        xiantiaorongheEvaluateFucou: '',
        xiantiaorongheEvaluateFucouSug: '',
        dafanweiLitishiEvaluateJingtai: '',
        dafanweiLitishiEvaluateJingtaiSug: '',
        // dafanweiLitishiEvaluateDongtai: '',
        // dafanweiLitishiEvaluateDongtaiSug: '',
        xiantiaoLitishiEvaluate: '',
        ruoshiyizhiEvaluate: '',
        ruoshiyizhiEvaluateSug: '',
        xieshiyizhiEvaluate: '',
        xieshiyizhiEvaluateSug: '',
        duibiminganduEvaluate: ''
    }
    };
  },
  mounted() {
    console.log(this.testResult)
    // console.log("testUser", this.testUser, this.testResult);
    this.formatTestResult();
  },
  methods: {
    formatTestResult() {
      if (this.testResult) {
        if (this.testResult.VISION_CHALLENGE) {
          this.checkResult.versionOs = this.testResult.VISION_CHALLENGE.leftData;
          this.checkResult.versionOd = this.testResult.VISION_CHALLENGE.rightData;
        }
        //Worth四孔灯
        if (this.testResult.WORTH_FOUR_LAMP_HOLE_CHALLENGE) {
          this.checkResult.worth4Number =
            this.testResult.WORTH_FOUR_LAMP_HOLE_CHALLENGE.value == "2.5"
              ? "有时2个 有时3个"
              : `${this.testResult.WORTH_FOUR_LAMP_HOLE_CHALLENGE.value}个`;

          this.checkResult.worth4Text =  mapWorth4[this.testResult.WORTH_FOUR_LAMP_HOLE_CHALLENGE.value];
          //   this.checkResult.tongshishiEvaluate = this.checkResult.worth4Text;
        }
        //知觉眼位
        if (this.testResult.PERCEPTUAL_EYE_POSITION) {
          this.checkResult.positionSuanshuShuiping = parseFloat(
            this.testResult.PERCEPTUAL_EYE_POSITION.data.jisuan.deviation_x
          );
          this.checkResult.positionSuanshuChuizhi = parseFloat(
            this.testResult.PERCEPTUAL_EYE_POSITION.data.jisuan.deviation_y
          );
          this.checkResult.positionPingjunShuiping = parseFloat(
            // this.testResult.PERCEPTUAL_EYE_POSITION.data.juedui.deviation_x
            this.testResult.PERCEPTUAL_EYE_POSITION.data.jisuan.deviation_x
          )
          this.checkResult.positionPingjunChuizhi = parseFloat(
            // this.testResult.PERCEPTUAL_EYE_POSITION.data.juedui.deviation_y;
            this.testResult.PERCEPTUAL_EYE_POSITION.data.jisuan.deviation_y
          );
          const shuipingFlg = Math.abs(this.checkResult.positionSuanshuShuiping) > 0.137 ||  Math.abs(this.checkResult.positionPingjunShuiping) > 0.137
          if (shuipingFlg) {
            this.checkResult.zhijueyanweiEvaluateShuiping ="异常"
            let sug = "双眼成像不对应，眼位控制力弱。一般负值越大越可能外斜，正值越大越可能存在内斜。当时可能存在"
            const shuipingFlag2 = this.positionPingjunShuiping<0 || this.checkResult.positionSuanshuShuiping<0
            sug += shuipingFlag2 ? "外斜" : "内斜"
            this.checkResult.zhijueyanweiEvaluateShuipingSug = sug + "。" + (shuipingFlag2 ? "建议融合（辐辏）训练" : "建议融合（分开）训练")
          } else {
            this.checkResult.zhijueyanweiEvaluateShuiping = "正常";
            this.checkResult.zhijueyanweiEvaluateShuipingSug = " 眼位可控制正位"
          }
          if (
            Math.abs(this.checkResult.positionSuanshuChuizhi) > 0.137 ||
            Math.abs(this.checkResult.positionPingjunChuizhi) > 0.137
          ) {
            this.checkResult.zhijueyanweiEvaluateChuizhi ="异常"
            this.checkResult.zhijueyanweiEvaluateChuizhiSug = "双眼成像不对应，一般值越大双眼斜视角越大，眼位控制力越差";
          } else {
            this.checkResult.zhijueyanweiEvaluateChuizhi = "正常";
            this.checkResult.zhijueyanweiEvaluateChuizhiSug = "眼位可控制正位"
          }
        }
        if (this.testResult.LINE_FUSION) {
          this.checkResult.xiantiaorongheFenkai = parseFloat(
            this.testResult.LINE_FUSION.data.fenkai
          );
          this.checkResult.xiantiaorongheFucou = parseFloat(
            this.testResult.LINE_FUSION.data.fucou
          );

          if (
            this.checkResult.xiantiaorongheFenkai < -4 ||
            this.checkResult.xiantiaorongheFenkai > -2
          ) {
            this.checkResult.xiantiaorongheEvaluateFenkai = "异常";
            this.checkResult.xiantiaorongheEvaluateFenkaiSug = "可能会视物模糊，阅读易疲劳，严重时可能会出现复视。建议融合训练；受影响的因素较多，结果仅供参考";
          } else {
            this.checkResult.xiantiaorongheEvaluateFenkai = "正常";
            this.checkResult.xiantiaorongheEvaluateFenkaiSug = "受影响的因素较多，结果仅供参考";
          }
          if (
            this.checkResult.xiantiaorongheFucou < 15 ||
            this.checkResult.xiantiaorongheFucou > 30
          ) {
            this.checkResult.xiantiaorongheEvaluateFucou = "异常";
            this.checkResult.xiantiaorongheEvaluateFucouSug = "可能会视物模糊、复视、头晕；阅读和近距离工作时会容易眼部不适，易视疲劳。建议融合训练；受影响的因素较多，结果仅供参考"
          } else {
            this.checkResult.xiantiaorongheEvaluateFucou = "正常";
            this.checkResult.xiantiaorongheEvaluateFucouSug = "受影响的因素较多，结果仅供参考";
          }
        }
        if (this.testResult.EXTENSIVENESS_STEREOPSIS && this.testResult.EXTENSIVENESS_STEREOPSIS.result) {
          const temp = this.testResult.EXTENSIVENESS_STEREOPSIS.result.split("");
          this.checkResult.dafanweilitishiDongtai = parseFloat(temp[12]);
          this.checkResult.dafanweilitishiJingtai = parseFloat(temp[4]);
          if (this.checkResult.dafanweilitishiJingtai > 1) {
            this.checkResult.dafanweiLitishiEvaluateJingtai = "存在立体视";
            this.checkResult.dafanweiLitishiEvaluateJingtaiSug = "继续观察";
          } else {
            this.checkResult.dafanweiLitishiEvaluateJingtai = "异常";
            this.checkResult.dafanweiLitishiEvaluateJingtaiSug = "继续观察";
          }

          if (this.checkResult.dafanweilitishiDongtai > 1) {
            this.checkResult.dafanweiLitishiEvaluateDongtai = "存在立体视";
            this.checkResult.dafanweiLitishiEvaluateDongtaiSug = "继续观察";
          } else {
            this.checkResult.dafanweiLitishiEvaluateDongtai = "异常";
            this.checkResult.dafanweiLitishiEvaluateDongtaiSug = "继续观察";
          }
        }
        if (this.testResult.LINE_STEREOPSIS && this.testResult.LINE_STEREOPSIS.result) {
          try {
            if (this.testResult.LINE_STEREOPSIS.result == "大于800秒") {
              this.checkResult.xiantiaolitishi = 900
            } else{
              this.checkResult.xiantiaolitishi = parseFloat(this.testResult.LINE_STEREOPSIS.result.split("秒")[0]);
            }
          } catch (e) {
          }
          if (this.checkResult.xiantiaolitishi <= 100) {
            this.checkResult.xiantiaoLitishiEvaluate = "正常";
            this.checkResult.xiantiaoLitishiEvaluateSug = "立体视可以影响对目标距离的判断及精细作业的能力。立体视正常，能够精确判断物体的深度感及自身位置关系，同时对弱视视力巩固有所帮助"
          } else if (this.checkResult.xiantiaolitishi <= 800) {
            this.checkResult.xiantiaoLitishiEvaluate = "轻度异常";
            this.checkResult.xiantiaoLitishiEvaluateSug = "部分立体视功能缺失，会对物体远近位置分辨存在失常，精细作业能力减弱。建议立体视训练"
          } else {
            this.checkResult.xiantiaolitishi = ">800";
            this.checkResult.xiantiaoLitishiEvaluate = "重度异常";
            this.checkResult.xiantiaoLitishiEvaluateSug = "没有立体视觉，对距离判断能力减弱，精细作业能力减弱，如走路易摔倒。建议立体视训练"
          }
        }
        if (this.testResult.AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT && this.testResult.AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT.result) {
          this.checkResult.ruoshiyizhipinghengdian = parseFloat(
            this.testResult.AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT.result
          );
          this.checkResult.ruoshiyizhiEvaluateSug = "建议脱抑制训练+同时视训练"
          if (this.checkResult.ruoshiyizhipinghengdian < 25) {
            this.checkResult.ruoshiyizhiEvaluate = "重度抑制";
          } else if (this.checkResult.ruoshiyizhipinghengdian > 75) {
            this.checkResult.ruoshiyizhiEvaluate = "中度抑制";
          } else if (this.checkResult.ruoshiyizhipinghengdian == 50) {
            this.checkResult.ruoshiyizhiEvaluate = "正常";
            this.checkResult.ruoshiyizhiEvaluateSug = ""
          } else {
            this.checkResult.ruoshiyizhiEvaluate = "轻度抑制";
          }
        }
        if (this.testResult.STRABISMUS_INHIBITION_EQUILIBRIUM_POINT && this.testResult.STRABISMUS_INHIBITION_EQUILIBRIUM_POINT.result) {
          this.checkResult.xieshiyizhipinghengdian = parseFloat(
            this.testResult.STRABISMUS_INHIBITION_EQUILIBRIUM_POINT.result
          );
          this.checkResult.xieshiyizhiEvaluateSug = "建议脱抑制训练+同时视训练"
          if (this.checkResult.xieshiyizhipinghengdian < 50) {
            this.checkResult.xieshiyizhiEvaluate = "重度抑制";
          } else if (this.checkResult.xieshiyizhipinghengdian == 100) {
            this.checkResult.xieshiyizhiEvaluate = "正常";
            this.checkResult.xieshiyizhiEvaluateSug = ""
          } else {
            this.checkResult.xieshiyizhiEvaluate = "轻度抑制";
          }
        }
      }
    },
    isNotNormal(value) {
      return value && value !== "正常" && !value.startsWith("正常") && value !== "存在立体视";
    }
  }
};
</script>

<template>
  <div class="newCheckReport">
    <el-row :gutter="24" class="basicRow moreBottomMargin">
      <el-col :span="3" class="rightCol">
        <img class="titleIcon" src="@/assets/mumuqingIcon.png" />
      </el-col>
      <el-col class="basicCol title centerCol" :span="20">{{testUser.hospitalName}}<br />
        视感知觉训练检查报告</el-col>
    </el-row>
    <el-row :gutter="24" class="basicRow moreBottomMargins">
      <el-col :offset="2" class="basicCol userInfo" :span="2">姓名：</el-col>
      <el-col class="basicCol reportText" :span="5">{{testUser.name || '--'}}</el-col>
      <el-col class="basicCol userInfo" :span="3" style="text-align: right;">性别：</el-col>
      <el-col class="basicCol reportText" :span="5">{{testUser.gender || '--'}}</el-col>
      <el-col class="basicCol userInfo" :span="3" style="text-align: right;">年龄：</el-col>
      <el-col class="basicCol reportText" :span="3">{{testUser.age || '--'}}</el-col>
    </el-row>
    <el-row :gutter="24" class="basicRow" v-if="picInfo.length > 0">
      <el-col :offset="2" class="basicCol userInfo" :span="22">对比敏感度</el-col>
    </el-row>
    <el-row :gutter="24" class="basicRow" v-if="picInfo.length > 0">
      <el-col :offset="2" class="basicCol userInfo" :span="22">
        <img
          class="iconStyle"
          v-for="(pictrue, index) in picInfo"
          :key="'pictrue' + index"
          :src="pictrue"
          :style="index > 0 ? {'margin-left': '50px'} : {}"
        />
      </el-col>
    </el-row>
    <el-row :gutter="24" class="basicRow" v-if="picInfo.length > 0">
      <el-col :offset="2" class="basicCol userInfo" style="font-size: 18px;" :span="22">检测提示</el-col>
    </el-row>
    <el-row :gutter="24" class="basicRow bottomPadding" v-if="picInfo.length > 0">
      <el-col
        :offset="2"
        class="basicCol reportText"
        style="color: #000"
        :span="22"
      >备注：明适应状态下检测参考范围</el-col>
    </el-row>
  <table cellpadding="0" cellspacing="0">
    <tr>
      <th style="width: 14%">检查项目</th>
      <th style="width: 15%">检测值</th>
      <th style="width: 15%">参考值</th>
      <th style="width: 28%">检测提示</th>
      <th style="width: 28%">处理建议</th>
    </tr>
    <tr v-if="checkResult.worth4Number">
      <td class="tdTitle">Worth四孔灯</td>
      <td>{{checkResult.worth4Number || '--'}}</td>
      <td>4个</td>
      <td :class="{redText: isNotNormal(checkResult.worth4Text && checkResult.worth4Text.result)}">{{checkResult.worth4Text.result || '--'}}</td>
      <td>{{checkResult.worth4Text.msg || '--'}}</td>
    </tr>
    <tr v-if="this.testResult.PERCEPTUAL_EYE_POSITION">
      <td rowspan="2" class="tdTitle">知觉眼位</td>
      <td>水平：{{checkResult.positionPingjunShuiping}}°</td>
      <td>水平 ≤ ±0.137°</td>
      <td :class="{redText: isNotNormal(checkResult.zhijueyanweiEvaluateShuiping)}">{{checkResult.zhijueyanweiEvaluateShuiping || '--'}}</td>
      <td>{{checkResult.zhijueyanweiEvaluateShuipingSug || '--'}}</td>
    </tr>
    <tr v-if="checkResult.positionPingjunShuiping || checkResult.positionPingjunChuizhi">
      <td>垂直：{{checkResult.positionPingjunChuizhi}}°</td>
      <td>垂直 ≤ ±0.137°</td>
      <td :class="{redText: isNotNormal(checkResult.zhijueyanweiEvaluateChuizhi)}">{{checkResult.zhijueyanweiEvaluateChuizhi || '--'}}</td>
      <td>{{checkResult.zhijueyanweiEvaluateChuizhiSug || '--'}}</td>
    </tr>
    <tr v-if="checkResult.xiantiaorongheFenkai || checkResult.xiantiaorongheFucou">
      <td rowspan="2" class="tdTitle">融合范围</td>
      <td>分开：{{checkResult.xiantiaorongheFenkai || '--'}} °</td>
      <td>分开-2～-4</td>
      <td :class="{redText: isNotNormal(checkResult.xiantiaorongheEvaluateFenkai)}">{{checkResult.xiantiaorongheEvaluateFenkai || '--'}}</td>
      <td>{{checkResult.xiantiaorongheEvaluateFenkaiSug || '--'}}</td>
    </tr>
    <tr v-if="checkResult.xiantiaorongheFenkai || checkResult.xiantiaorongheFucou">
      <td>辐辏：{{checkResult.xiantiaorongheFucou || '--'}} °</td>
      <td>辐辏+15～+30</td>
      <td :class="{redText: isNotNormal(checkResult.xiantiaorongheEvaluateFucou)}">{{checkResult.xiantiaorongheEvaluateFucou || '--'}}</td>
      <td>{{checkResult.xiantiaorongheEvaluateFucouSug || '--'}}</td>
    </tr>
    <tr v-if="checkResult.dafanweilitishiJingtai || checkResult.dafanweilitishiDongtai">
      <td rowspan="2" class="tdTitle">大范围立体视</td>
      <td>静态：{{checkResult.dafanweilitishiJingtai > -1 ? `${checkResult.dafanweilitishiJingtai}/3` : '--'}}</td>
      <td>≥静态2/3</td>
      <td :class="{redText: isNotNormal(checkResult.dafanweiLitishiEvaluateJingtai)}">{{checkResult.dafanweiLitishiEvaluateJingtai || '--'}}</td>
      <td>{{checkResult.dafanweiLitishiEvaluateJingtaiSug || '--'}}</td>
    </tr>
    <tr v-if="checkResult.dafanweilitishiJingtai || checkResult.dafanweilitishiDongtai">
      <td >动态：{{checkResult.dafanweilitishiDongtai > -1 ? `${checkResult.dafanweilitishiDongtai}/3` : '--'}}</td>
      <td>≥动态2/3</td>
      <td :class="{redText: isNotNormal(checkResult.dafanweiLitishiEvaluateDongtai)}">{{checkResult.dafanweiLitishiEvaluateDongtai || '--'}}</td>
      <td>{{checkResult.dafanweiLitishiEvaluateDongtaiSug || '--'}}</td>
    </tr>
    <tr v-if="checkResult.xiantiaolitishi">
      <td class="tdTitle">线条立体视</td>
      <td>{{checkResult.xiantiaolitishi || '--'}}″</td>
      <td>100″以内</td>
      <td :class="{redText: isNotNormal(checkResult.xiantiaoLitishiEvaluate)}">{{checkResult.xiantiaoLitishiEvaluate || '--'}}</td>
      <td>{{checkResult.xiantiaoLitishiEvaluateSug || '--'}}</td>
    </tr>
    <tr v-if="checkResult.ruoshiyizhipinghengdian || checkResult.xieshiyizhipinghengdian">
      <td rowspan="2" class="tdTitle">抑制平衡点</td>
      <td>弱视平衡点：{{checkResult.ruoshiyizhipinghengdian || '--'}}</td>
      <td>50</td>
      <td :class="{redText: isNotNormal(checkResult.ruoshiyizhiEvaluate)}">{{checkResult.ruoshiyizhiEvaluate || '--'}}</td>
      <td>{{checkResult.ruoshiyizhiEvaluateSug || '--'}}</td>
    </tr>
    <tr v-if="checkResult.ruoshiyizhipinghengdian || checkResult.xieshiyizhipinghengdian">
      <td>斜视平衡点：{{checkResult.xieshiyizhipinghengdian || '--'}}</td>
      <td>100</td>
      <td :class="{redText: isNotNormal(checkResult.xieshiyizhiEvaluate)}">{{checkResult.xieshiyizhiEvaluate || '--'}}</td>
      <td>{{checkResult.xieshiyizhiEvaluateSug || '--'}}</td>
    </tr>
  </table>
    <el-row :gutter="24" class="basicRow bottomPadding testDate">
      <el-col class="basicCol userInfo rightCol" :span="22">检测日期：{{testUser.date || '--'}}</el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.newCheckReport {
  margin-top: 40px;
  .basicRow {
    margin-bottom: 0px;
    color: #000000;
    .titleIcon {
      width: 100px;
    }
    .title {
      font-size: 26px;
      font-weight: bold;
    }
    .userInfo {
      font-size: 16px;
      font-weight: bold;
    }
    .reportText {
      font-size: 14px;
    }
  }
  .bottomMargin {
    margin-bottom: 20px;
  }
  .moreBottomMargin {
    margin-bottom: 30px;
  }
  .bottomPadding {
    padding-bottom: 20px;
  }
  .bottomLine {
    border-bottom: 2px solid #000000;
  }
  .testDate {
    margin-top: 30px;
  }

  .iconStyle {
    width: 300px;
    height: 200px;
    // margin: 10px auto 10px;
  }

  .el-row {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  .centerCol {
    text-align: center;
  }
  .rightCol {
    text-align: right;
  }
  .el-col {
    padding-left: 0px !important;
    padding-right: 0px !important;
    min-width: 1px;
  }

  .childrenRow {
    border-bottom: 1px solid #000000;
    margin-bottom: -1px;

    &:last-child {
      border-bottom: 0px solid #000000;
    }
  }

  .basicCol {
    // border-right: 1px solid #000000;
    overflow: hidden;

    &:last-child {
      //   border-right: 0px solid #000000;
    }
  }

  table { border: 1px solid #000; border-width: 1px 0 0 1px; padding: 0; margin: 0; width:100%}
  th,td { border: 1px solid #000; border-width: 0 1px 1px 0; padding: 0; margin: 0; line-height:1.5}
  th, td.tdTitle{font-weight: bold; text-align: center; font-size: 18px;}
  td{text-align: center; height: 76px;}
  td.redText{color: #ff0000;}
}
</style>



// WEBPACK FOOTER //
// src/components/vision/newCheckReport.vue